// https://masteringjs.io/tutorials/fundamentals/email-regex
const EMAIL_REGEX = /(?:[a-z0-9+!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i

const BAD_EMAIL_FORMAT_ERROR = 'Please enter a valid email format. (e.g. simba@priderock.edu)';

export function validateEmail(email) {
  const errors = [];
  const formattedEmail = email.trim().toLowerCase();

  if (!formattedEmail.match(EMAIL_REGEX)) {
    errors.push(BAD_EMAIL_FORMAT_ERROR);
  }

  return errors.length ? errors : null;
}

const BLANK_PASSWORD_ERROR = 'Please enter your password';
const BLANK_CONFIRM_PASSWORD_ERROR = "Can't be empty!";

function validatePassword(password) {
  const errors = [];
  if (!password) {
    errors.push(BLANK_PASSWORD_ERROR);
  }

  return errors.length ? errors : null;
}

export function validateLoginForm(email, password) {
  const emailErrors = validateEmail(email);
  const passwordErrors = validatePassword(password);

  if (emailErrors || passwordErrors) {
    return {
      email: emailErrors,
      password: passwordErrors
    };
  } else {
    return null;
  }
}

const MINIMUM_PASSWORD_LENGTH = 8;

const NUMERIC_REGEX = /[0-9]/;
const UPPERCASE_REGEX = /[A-Z]/;
const LOWERCASE_REGEX = /[a-z]/;

const MINIMUM_CHARACTER_LENGTH_ERROR = 'Password must have at least 8 characters';
const MINIMUM_UPPER_LOWER_CASE_ERROR = 'Password must have at least 1 uppercase and 1 lowercase letter';
const MINIMUM_NUMBER_DIGITS_ERROR = 'Password must have at least 1 number';

function validateNewPassword(password) {
  const validateEmptyPassword = validatePassword(password);

  const errors = [];

  if (validateEmptyPassword) {
    return validateEmptyPassword;
  }

  if (password.length < MINIMUM_PASSWORD_LENGTH) {
    errors.push(MINIMUM_CHARACTER_LENGTH_ERROR);
  }

  if (!password.match(NUMERIC_REGEX)) {
    errors.push(MINIMUM_NUMBER_DIGITS_ERROR);
  }

  if (!password.match(UPPERCASE_REGEX) || !password.match(LOWERCASE_REGEX)) {
    errors.push(MINIMUM_UPPER_LOWER_CASE_ERROR);
  }

  return errors.length ? errors : null;
}

const CONFIRM_PASSWORD_ERROR = 'Must match password'

function validateConfirmPassword(password, confirmPassword) {
  const errors = [];

  const validateEmptyPassword = validatePassword(confirmPassword);

  if (validateEmptyPassword) {
    errors.push(BLANK_CONFIRM_PASSWORD_ERROR);

    return errors;
  }

  if (password !== confirmPassword) {
    errors.push(CONFIRM_PASSWORD_ERROR);
  }


  return errors.length ? errors : null;
}

export function validateChangePasswordForm(password, confirmPassword) {
  const passwordErrors = validateNewPassword(password);
  const confirmPasswordErrors = validateConfirmPassword(password, confirmPassword);

  if (passwordErrors || confirmPasswordErrors) {
    return {
      password: passwordErrors,
      confirmPassword: confirmPasswordErrors
    };
  } else {
    return null;
  }
}

export function checkIfLoggedInOrTermsAndConditions(mustAcceptTermsAndConditions, loggedIn) {
  return (mustAcceptTermsAndConditions || loggedIn);
}
